export default {"src":"/_next/static/media/line-01.2f850122.svg","height":77,"width":124,"blurWidth":0,"blurHeight":0};